import styled from 'styled-components';
import { default as C } from '@assets/themes/colors';

interface IProps {
  active?: boolean;
}

export const Root = styled.div`
  position: relative;
`;

export const CheckBoxLabel = styled.label`
  position: absolute;
  top: 3px;
  left: 0;
  width: 29px;
  height: 12px;
  border-radius: 15px;
  background-color: ${(props: IProps) => (props.active ? '#75839d': '#bdbdbd')};
  cursor: pointer;
  &::after {
    content: "";
    display: block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin-top: -3px;
    background:  #f3f3f3;
    box-shadow: 0 4px 10px 5px rgba(0, 0, 0, 0.18);
    transition: 0.2s;
    background: ${(props: IProps) => (props.active ? '#282828': '#f5f5f5')};
  }
`;

export const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 29px;
  height: 12px;
  &:checked + ${CheckBoxLabel} {
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      margin-left: 15px;
      transition: 0.2s;
    }
  }
`;